import { render, staticRenderFns } from "./CustomerAccountWatch.vue?vue&type=template&id=053f28e2&"
import script from "./CustomerAccountWatch.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports